import { useState } from "react"
import Todo from "./todo"
import './todoApp.css'

export default function TodoApp() {
    const [title, setTitle] = useState("");
    const [todos, setTodos] = useState([]);
    /* const [editItem, setEditItem] = useState(null); */

    function handleInputChange(e) {
        setTitle(e.target.value);
    }

    function handleSubmit(e) {
        e.preventDefault();
        const newTodo = {
            id: Date.now(),
            title: title,
            completed: false,
        };

        const oldTodos = [...todos];
        oldTodos.unshift(newTodo);

        setTodos(oldTodos);
        setTitle("");
    }

    function handleDelete(id) {
        const tempTodos = todos.filter((item) => item.id !== id);

        setTodos([...tempTodos]);
    }

    function handleUpdate(id, value) {
        const temp = [...todos];
        const item = temp.find((item) => item.id === id);
        item.title = value;
        setTodos([...temp]);
    }

    function handleCheckboxChange(id, status) {
        const temp = [...todos];
        const item = temp.find((item) => item.id === id);
        item.completed = status;

        console.log("Holis");
        setTodos([...temp]);
    }

    return (
        <div className="todoContainer">
            <form onSubmit={handleSubmit} className="todoCreateForm">
                <input
                    onChange={handleInputChange}
                    value={title}
                    className="todoInput"
                    placeholder="Write things to do..."
                />
                <input
                    value="Create todo"
                    type={"submit"}
                    className="buttonCreate"
                />
            </form>

            <div className="todosContainer">
                {
                    todos.map((item) => (
                        <Todo
                            key={item.id}
                            item={item}
                            onUpdate={handleUpdate}
                            onDelete={handleDelete}
                            onComplete={handleCheckboxChange}
                        />
                    ))
                }
            </div>
        </div>
    );
}

